module.exports = __webpack_public_path__ + "media/images/kid/kid_avatar_01-5dd6edcf959e68e41ff0c8bdd29b9aff.png";